import { render, staticRenderFns } from "./remove_account.vue?vue&type=template&id=3d3d118d"
import script from "./remove_account.vue?vue&type=script&lang=js"
export * from "./remove_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports